import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon
} from 'reactstrap';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2';
import moment from 'moment';

import IconSave from 'react-icons/lib/md/save';

import * as actions from '../../actions/factura';

import Select from 'react-select';

import {api, API_URL} from '../../actions/_request';

import ReactTable from "react-table";
import "react-table/react-table.css";
const SubmitLoad = () => (
	<div className="p-2">
		<Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
	</div>
);
const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String((row[id]+'').toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };




class TicketModal extends React.Component
{
	constructor(props)
	{
		super(props)

		this.state = {
            factura:[],
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
	}
   
    handleInputChange(event) {
        let {factura} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        factura[name] = value;
     
        this.setState({
            factura : factura
        });
    }

    componentDidMount()
    {
        let factura=this.props.documento;
        console.log('modal correo factura--->',factura);
        // console.log('cliente--->',cliente);
        this.setState({
        factura: factura,
        });          
    }

    

    

    handleSelectChange(select, name) {

        const value = select === null ? null : select.value;
        this.setState({ 
                [name]: value,
        });
    }

    

	handleSubmit(evt)
	{
		evt.preventDefault();
        let {factura} = this.state;
        
        let objeto={
            id:factura.value,
            nota_interna:factura.nota_interna,
        }
      
    
        let self =this;

        this.props.update_total(objeto, (data) => {
          self.props.alerta({
            mensaje:"Factura Modificada  Correctamente",
            tipo:"success",
            creacion:moment().format('Y-MM-DD H:m:s'),
          });
          self.props.toggle();
      });

	}

	render()
	{
       // console.log('lista de correos--->',this.state.cc);
       let {factura}=this.state;
		
		return(

			<Modal isOpen={this.props.open} toggle={this.props.toggle} style={{marginTop: '0'}} className="default modal-lg">
				<form onSubmit={this.handleSubmit}>
                <ModalHeader toggle={this.props.toggle}>Nota</ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-md-12"> 
                                    <div className="form-group">
                                      <label className>Factura: {factura.factura}</label>
                                  </div>
                        </div>
                        <div className="col-md-12"> 
                                    <div className="form-group">
                                      <label className>Cliente: {factura.cliente}</label>
                                  </div>
                        </div>
                    </div>
                    <div className="row">
                    <div className="col-md-11"> 
                                <div className="form-group">
                                    <Label>Nota</Label>
                                    <Input
                                    className='texto_normal'
                                    placeholder=""
                                    rows={10}                                                        
                                    type="textarea"
                                    name="nota_interna"
                                    maxLength={65534}
                                    value={factura.nota_interna}
                                    onChange={ this.handleInputChange}
                                    />
                                </div>
                              </div>
                    </div>
                    
                </ModalBody>
                <ModalFooter>
                    {
                    	this.props.factura.saving ?
                    	<SubmitLoad /> : 
                    	<div>
                    		<Button color="primary" type="submit" >
                    			Enviar
                    		</Button>{' '}
                    		<Button color="secondary" onClick={this.props.toggle}>
		                    	Cancel
		                    </Button>
                    	</div>
                    }
                </ModalFooter>
                </form>
            </Modal>
		);
	}
}

function mapStateToProps(state, ownProps) {
    return {
        factura : state.factura,
    }
};

export default connect(mapStateToProps, actions)(TicketModal)


// WEBPACK FOOTER //
// ./src/components/facturarTicket/ModalNota.js